import React from "react";

export const ArrowUpRight = ({ color = "white" }: { color?: string }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2431 0.583374H4.70139V1.50699H9.59007L0.103195 10.9939L0.756188 11.6468L10.2431 2.15998V7.04865H11.1667V1.50699C11.1667 0.997614 10.7524 0.583374 10.2431 0.583374Z"
      fill={color}
    />
  </svg>
);
